"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Option = _interopRequireWildcard(require("../Option/Option"));

var _helpers = require("./helpers");

var _OptionList = _interopRequireWildcard(require("./OptionList.style"));

var _Loader = _interopRequireDefault(require("../../Loader"));

/* eslint react/no-did-mount-set-state: 0 */
// const notFoundOption = ;
var OptionList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(OptionList, _PureComponent);

  function OptionList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, OptionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(OptionList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      optionHeight: 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setRef", function (node) {
      _this.node = node;
    });
    return _this;
  }

  (0, _createClass2.default)(OptionList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _ref = this.node.firstChild || {},
          offsetHeight = _ref.offsetHeight;

      this.setState({
        optionHeight: offsetHeight
      }, function () {
        return (0, _helpers.scrollToCenter)(_this2.props.focused, _this2.node);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var focused = _ref2.focused;
      (0, _helpers.scrollToNextFocused)(focused, this.props.focused, this.node);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.loading) {
        return _react.default.createElement(_OptionList.default, {
          innerRef: this.setRef
        }, _react.default.createElement(_Loader.default, {
          width: 30,
          height: 30
        }));
      }

      var _this$props = this.props,
          options = _this$props.options,
          selectedOptions = _this$props.selectedOptions,
          handleOptionClick = _this$props.handleOptionClick,
          focused = _this$props.focused,
          customOption = _this$props.customOption,
          handleOptionHover = _this$props.handleOptionHover,
          notFoundOption = _this$props.notFoundOption,
          showClearBtn = _this$props.showClearBtn,
          clearSelectedOptions = _this$props.clearSelectedOptions;
      var optionHeight = this.state.optionHeight;
      var selectedValues = selectedOptions.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      });
      return _react.default.createElement(_OptionList.default, {
        innerRef: this.setRef,
        style: {
          maxHeight: optionHeight * 5
        }
      }, options.length ? options.map(function (option, i) {
        return _react.default.createElement(_Option.default, {
          option: option,
          key: option.value,
          focused: i === focused,
          index: i,
          customOption: customOption,
          handleClick: handleOptionClick,
          handleOptionHover: handleOptionHover,
          selected: selectedValues.includes(option.value)
        });
      }) : _react.default.createElement(_Option.default, {
        option: notFoundOption
      }), showClearBtn ? [_react.default.createElement(_OptionList.BorderTop, null), _react.default.createElement(_OptionList.ClearBtn, {
        onClick: clearSelectedOptions
      }, "Clear (Action)")] : null);
    }
  }]);
  return OptionList;
}(_react.PureComponent);

OptionList.defaultProps = {
  customOption: null,
  notFoundOption: {
    value: '',
    label: 'Not found',
    disabled: true
  }
};
OptionList.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.shape(_Option.optionPropType)).isRequired,
  selectedOptions: _propTypes.default.arrayOf(_propTypes.default.shape(_Option.optionPropType)).isRequired,
  handleOptionClick: _propTypes.default.func.isRequired,
  focused: _propTypes.default.number.isRequired,
  customOption: _propTypes.default.func,
  handleOptionHover: _propTypes.default.func.isRequired,
  notFoundOption: _propTypes.default.shape({})
};
var _default = OptionList;
exports.default = _default;